// Third Controls
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from '@mui/material';
import { MapUtilitiesTypes } from '../MapUtilitiesMenu/enums';

import NewLayer from './components/NewLayer'
import VehicleTrail from './components/VehicleTrail'
import Route from './components/Route'
import { Loading } from 'Components';

//Actions
import { selectModuleMapSettings } from "Redux/actions";
import LayerKmz from './components/LayerKmz';


const LayerMap = (props) => {

  const dispatch = useDispatch();
  const { messages, onShowMapSettings, mapRef } = props
  const [layerType, setLayerType] = useState('');
  const [errorType, setErrorType] = useState(false);
  const [view, setView] = useState(0);

  const handleView = (view) => {
      if(view || view === 0) return setView(view)
      switch(layerType){
        case 'vehicleTrail':
          return setView(2)
        case 'route':
          return setView(1)
        case 'layerKmz':
          return setView(3)
        default:
          return setView(0)
      }
  }

  /********************************************************
 * Restore initial state
 ********************************************************/
  const handleSection = () => {
    dispatch(selectModuleMapSettings(MapUtilitiesTypes.Default))
  }

  const loadingAllRoutes = useSelector(state => state.realtimeMapLayerMapModuleRedux.loadingAllRoutes);

  const loadVehicleTrailsLayer = useSelector(state => state.realtimeMapLayerMapModuleRedux.loadVehicleTrailsLayer);
  let title = [
    `${messages['realtimemaps_layer_map_add_new_layer']}`,
    `${messages['realtimemaps_layer_map_add_new_layer']} - ${messages['realtimemaps_layer_map_route']}`,
    `${messages['realtimemaps_layer_map_add_new_layer']} - ${messages['realtimemaps_layer_map_vehicle_trail']}`,
    `${messages['realtimemaps_layer_map_add_new_layer']}`
  ];

  return (
    <div>
      <div>
        <h2 style={{ marginTop: 0, textAlign: 'center' }}>{title[view]}</h2>
      </div>

      {view === 0 && (
        <div>
          <div style={{ marginBottom: 10 }}>
            <label className={`menuItem`} onClick={(e) => handleSection()} >
              {messages[`maputilities_back`]}
            </label>
          </div>
          <NewLayer
            messages={messages}
            layerType={layerType}
            setLayerType={setLayerType}
            handleView={handleView}
            onShowMapSettings={handleSection}
            errorType={errorType}
            mapRef={mapRef}
          />
        </div>
      )}
      {view === 1 && (
        <Route
          handleView={handleView}
          messages={messages}
          mapRef={mapRef}
        />
      )}
      {view === 2 && (
        <VehicleTrail
          messages={messages}
          handleView={handleView}
        />
      )}
      {view === 3 && (
        <LayerKmz
          handleView={handleView}
          mapRef={mapRef}
        />
      )}
      {loadingAllRoutes || loadVehicleTrailsLayer && (
        <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" >
          <Grid item xs={3} style={{ paddingTop: 20 }} >
            <Loading overlay show />
          </Grid>
        </Grid>)}
    </div>
  )
}

export default LayerMap;